export default () => ({
    options: null,
    variantData: null,
    currentVariantId: null,
    currentVariantAvailable: null,
    currentVariantTitle: null,
    productUrl: null,
    section: null,
    available: true,
    addToCartText: null,
    soldOutText: null,
    sizeOptionText: null,
    chooseASize: false,
    open: false,
    variants: [],
  
    initVariants(variant) {
      if (!variant) this.chooseASize = true;
  
      this.options = Array.from(
        this.$refs.variantPicker.querySelectorAll("input:checked"),
        (select) => select.value
      );
      this.sizeOptionText = this.options[1];
      if (this.sizeOptionText === "ONESI") {
        this.sizeOptionText = "Onesize";
      }
    },
  
    updateOptions() {
      this.options = Array.from(
        this.$refs.variantPicker.querySelectorAll("input:checked"),
        (select) => select.value
      );
      this.sizeOptionText = this.options[1];
      if (this.sizeOptionText === "ONESI") {
        this.sizeOptionText = "Onesize";
      }
      this.updateMasterId();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();
      this.setAvailability();
      this.chooseASize = false;
    },
  
    updateMasterId() {
      let variantObj = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
  
      this.currentVariantId = variantObj.id;
      this.currentVariantAvailable = variantObj.available;
      this.currentVariantTitle = variantObj.title;
    },
  
    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(
          this.$refs.variantPicker.querySelector('[type="application/json"]')
            .textContent
        );
      return this.variantData;
    },
  
    updateURL() {
      if (!this.currentVariantId) return;
      window.history.replaceState(
        {},
        "",
        `${this.productUrl}?variant=${this.currentVariantId}`
      );
    },
  
    renderProductInfo() {
      fetch(`${this.productUrl}?variant=${this.currentVariantId}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const source = html.getElementById(`price-${this.section}`);
          const sourceQuickshop1 = html.getElementById(
            `price-qs1-${this.section}`
          );
          const sourceQuickshop2 = html.getElementById(
            `price-qs2-${this.section}`
          );
          const sourceCartNotice = html.getElementById(`cn-${this.section}`);
          const sourceAPrice = html.getElementById(`ap-${this.section}`);
          const sourceQuickshopAPrice = html.getElementsByName(
            `properties[_actualprice]`
          );
  
          const dest = document.getElementById(`price-${this.section}`);
          const destQuickshop1 = document.getElementById(
            `price-qs1-${this.section}`
          );
          const destQuickshop2 = document.getElementById(
            `price-qs2-${this.section}`
          );
          const destCartNotice = document.getElementById(`cn-${this.section}`);
          const destAPrice = document.getElementById(`ap-${this.section}`);
          const destQuickshopAPrice = document.getElementById(
            `ap-${this.section}`
          );
  
          // Update values
          if (source && dest) dest.innerHTML = source.innerHTML;
          if (sourceAPrice && destAPrice) destAPrice.value = sourceAPrice.value;
          if (sourceCartNotice && destCartNotice)
            destCartNotice.innerHTML = sourceCartNotice.innerHTML;
          if (sourceQuickshop1 && destQuickshop1)
            destQuickshop1.innerHTML = sourceQuickshop1.innerHTML;
          if (sourceQuickshop2 && destQuickshop2)
            destQuickshop2.innerHTML = sourceQuickshop1.innerHTML;
  
          if (sourceQuickshopAPrice && destQuickshopAPrice) {
            if (sourceQuickshopAPrice[0]) {
              destQuickshopAPrice.value = sourceQuickshopAPrice[0].value;
            }
          }
  
          // this.updateSubmitButton();
        });
  
      // TODO
      // Add availability and addToCartBtn state from fetch
    },
  
    updateVariantInput() {
      const inputs = document.querySelectorAll('input[name="id"]');
      for (const input of inputs) {
        input.value = this.currentVariantId;
      }
    },
  
    isVariantAvailable(text) {
      const variantData =
        this.variantData ||
        JSON.parse(
          this.$refs.variantPicker.querySelector('[type="application/json"]')
            .textContent
        );
      const variant = variantData.find((variant) => variant.option2 === text);
      if (variant) {
        if (variant.available) {
          return true;
        }
        return false;
      }
    },
    updateSubmitButton() {
      this.$refs.submitBtnWrapper.querySelector("button").dataset.scrollLabel =
        this.currentVariantAvailable ? this.addToCartText : this.soldOutText;
      this.$refs.submitBtnWrapper.querySelector("button").disabled = this
        .currentVariantAvailable
        ? false
        : true;
    },

    setAvailability() {
      this.variants.forEach(function (arrayItem) {
        if (this.currentVariantId == arrayItem.id) {
  
          if (arrayItem.available) {
            if(arrayItem.available == 'true') {
              this.currentVariantAvailable = true;  
            } else {
              this.currentVariantAvailable = false;  
            }
          }
  
          this.variantInventoryQuantity = arrayItem.quantity;
        }
      }.bind(this));
      // dispatch to button
      this.$dispatch('add-to-cart-text', this.currentVariantAvailable); 
    },

    setVariants(id, quantity, available) {
      this.variants.push({
        id: id,
        quantity: quantity,
        available: available
      });
    },
  });
  